import { EStandard } from './enums/EStandard'
import { getStandard } from './getStandard'
import { transformSDCardLogToChartPackets } from './sdCard/transformSDCardLogToChartPackets'
import { transformTelemetryLogToChartPackets } from './telemetry/transformTelemetryLogToChartPackets'
import { sampleArray } from './utils'

export function transformLogToChartPackets(
    content: string,
    forceStandard?: EStandard,
    sampleRate?: number,
): IChartPackets & { standard: EStandard; timestampRange: [number, number] } {
    const standard = forceStandard || getStandard(content)
    let packets: IChartPackets & { standard: EStandard } = {
        standard: EStandard.simulator,
        dpr: [],
        tankPressures: [],
        ticks: [],
        modes: [],
    }
    let timestampRange: [number, number] = [0, 0]

    if (standard === EStandard.telemetry) {
        const telemetryPackets = transformTelemetryLogToChartPackets(content)
        packets = { ...telemetryPackets, standard: EStandard.telemetry }
    }

    if (standard === EStandard.sdCard) {
        const sdCardPackets = transformSDCardLogToChartPackets(content)
        packets = { ...sdCardPackets, standard: EStandard.sdCard }
    }

    // TODO: add simulator
    if (packets.standard === EStandard.simulator) {
        throw new Error('Unsupported standard')
    }

    // TODO: check all packets for earliest and latest timestamps, not just dpr
    if (packets.dpr.length) {
        timestampRange = [packets.dpr[0].timestamp, packets.dpr[packets.dpr.length - 1].timestamp]
    }

    if (sampleRate) {
        packets.dpr = sampleArray(packets.dpr, sampleRate)
        packets.tankPressures = sampleArray(packets.tankPressures, sampleRate)
        packets.ticks = sampleArray(packets.ticks, sampleRate)
        packets.modes = sampleArray(packets.modes, sampleRate)
    }

    return { ...packets, timestampRange }
}

export interface IChartPackets {
    dpr: IDprPacket[]
    tankPressures: ITankPressurePacket[]
    ticks: ITickPacket[]
    modes: IModePacket[]
    magnitudes?: {
        dpr?: string
        lox?: string
        fuel?: string
        battery?: string
    }
}

interface IBasePacket {
    timestamp: number
}

interface IDprPacket extends IBasePacket {
    dpr: number
}

interface ITankPressurePacket extends IBasePacket {
    lox: number
    fuel: number
}

interface ITickPacket extends IBasePacket {
    lox: number
    fuel: number
}

interface IModePacket extends IBasePacket {
    lox: number
    fuel: number
}
